"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParamsKey = exports.useParamsKeys = void 0;
const react_router_dom_1 = require("react-router-dom");
const useParamsKeys = (keys = ['id']) => {
    const values = {};
    const params = react_router_dom_1.useParams();
    keys.forEach((k) => {
        values[k] = params[k];
    });
    return values;
};
exports.useParamsKeys = useParamsKeys;
const useParamsKey = (key = 'id') => {
    const params = react_router_dom_1.useParams([key]);
    return params[key];
};
exports.useParamsKey = useParamsKey;
//# sourceMappingURL=useParamsKey.js.map